export default {
  sections: {
    settings: 'Instellingen',
  },
  status_switch: {
    label: 'Loyaliteitsprogramma',
    on: 'Aan',
    off: 'Uit',
    description: 'Klanten verdienen cashback bij elke bestelling en kunnen dit inwisselen bij het afrekenen.',
    description_missing: 'Sla de onderstaande instellingen op om uw loyaliteitsprogramma te starten.',
  },
  alerts: {
    off: 'Uw loyaliteitsprogramma is uitgeschakeld. Klanten verdienen geen cashback op nieuwe bestellingen, kunnen hun punten niet inwisselen en zien het programma niet in uw winkel. Reeds verzamelde punten blijven behouden en vervallen zoals gebruikelijk.',
    expired: 'Uw loyaliteitsprogramma is beëindigd. Schakel het in om het zonder einddatum opnieuw te starten.',
  },
  form: {
    title: {
      label: 'Titel',
    },
    percentage: {
      label: 'Cashbackpercentage',
      validation: {
        required: 'Cashbackpercentage is verplicht',
        min: 'Minimum cashbackpercentage is {{value}}%',
        max: 'Maximum cashbackpercentage is {{value}}%',
      },
    },
    point_lifetime: {
      label: 'Hoeveel dagen wilt u uw klanten geven om de punten te gebruiken?',
      validation: {
        min: 'Minimaal {{value}} dagen voor vervaldatum punten',
      },
    },
    min_spending_limit: {
      label: 'Minimale bestedingslimiet voor cashback',
      validation: {
        required: 'Minimale bestedingslimiet is verplicht',
        gt_zero: 'Minimale bestedingslimiet moet groter zijn dan 0',
        lt_max_spending_limit: 'Minimale bestedingslimiet moet lager zijn dan de maximale bestedingslimiet',
      },
    },
    max_spending_limit: {
      label: 'Maximale bestedingslimiet voor cashback',
      validation: {
        required: 'Maximale bestedingslimiet is verplicht',
        gt_min_spending_limit: 'Maximale bestedingslimiet moet hoger zijn dan de minimale bestedingslimiet',
      },
    },
    has_welcome_bonus: {
      label: 'Welkomstbonus',
      description: 'Geef nieuwe klanten een aanmeldcashbackbonus',
    },
    welcome_bonus: {
      label: 'Waarde welkomstbonus',
    },
    has_end_date: {
      label: 'Duur',
      options: {
        false: 'Oneindig',
        true: 'Met specifieke einddatum',
      },
    },
    end_date: {
      label: 'Einddatum',
    },
    has_mobile_app_signup_bonus: {
      label: 'Mobiele app aanmeldbonus',
      description: 'Beloon gebruikers die voor het eerst inloggen via de mobiele app',
    },
    mobile_app_signup_bonus: {
      label: 'Bonusbedrag',
    },
  },
  tags: {
    inactive: 'Niet actief',
    active: 'Actief',
    expired: 'Verlopen',
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    changes_got_saved: 'Wijzigingen opgeslagen',
    failed_to_save_changes: 'Opslaan van wijzigingen mislukt',
    turned_on: 'Loyaliteitsprogramma ingeschakeld',
    turned_off: 'Loyaliteitsprogramma uitgeschakeld',
  },
};
